'use client'

import styled from "styled-components";
import {getColor} from "@/pipes/theme.pipe";

export const ErrorMessageStyled = styled.span`
    display: flex;
    color: ${getColor('danger')};
    font-size: 13px;
    margin: 6px 0 0 11px;
`